import { FormPageInputItemTextZipCodeWithoutHyphen } from 'backend';
import {
  searchForAddressByZipCode,
  SearchForAddressByZipCodeContent,
} from 'fetcher';
import { useState } from 'react';
import { useApiEndpoint } from '../../store';

type SearchAddressPayload = {
  zipCode: FormPageInputItemTextZipCodeWithoutHyphen['zipCode'];
};

export type UseSearchForAddressByZipCodeReturnType = {
  searchForAddress: (
    payload: SearchAddressPayload
  ) => Promise<SearchForAddressByZipCodeContent | null>;
  searching: boolean;
};

export const useSearchForAddressByZipCode =
  (): UseSearchForAddressByZipCodeReturnType => {
    const [searching, setSearching] = useState(false);
    const apiEndpoint = useApiEndpoint();

    const searchForAddress = async ({ zipCode }: SearchAddressPayload) => {
      if (!zipCode) {
        return null;
      }
      setSearching(true);
      try {
        const response = await searchForAddressByZipCode(
          zipCode,
          apiEndpoint?.searchZipCode
        );
        setSearching(false);
        return response.zipcode.a1 ?? null;
      } catch (_) {
        setSearching(false);
        return null;
      }
    };

    return {
      searching,
      searchForAddress,
    };
  };
